import React from "react";
import MainHeader from "./Header";

const FinalHeader = () => {
  return (
    <header>
      <MainHeader />
    </header>
  );
};

export default FinalHeader;
